import { useState, type InputHTMLAttributes } from 'react';
import { IconEye, IconEyeOff } from './Icons';
import { useT } from '../lib/i18n';

/** Password field with an eye button to show or hide what is typed. */
export function PasswordInput(props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) {
  const [shown, setShown] = useState(false);
  const t = useT();
  return (
    <div className="password-field">
      <input {...props} type={shown ? 'text' : 'password'} spellCheck={false} autoCapitalize="off" />
      <button type="button" className="password-eye" onClick={() => setShown((v) => !v)}
        aria-label={shown ? t('Hide password') : t('Show password')} title={shown ? t('Hide password') : t('Show password')}>
        {shown ? <IconEyeOff /> : <IconEye />}
      </button>
    </div>
  );
}
